export const menus = [{
    title: '控制管理',
    name: 'controls',
    icon: 'dashboard',
    children: [{
        title: '测试环境',
        name: 'sandbox'
    }, {
        title: '我的应用',
        name: 'apps'
    }, {
        title: '我的代理商',
        name: 'agents'
    }]
}, {
    title: '设置',
    name: 'settings',
    icon: 'setting',
    children: [{
        title: '信息设置',
        name: 'info'
    }]
}]